export default {
  back: 'Înapoi la campanii',
  title: 'Campanie',
  sent_at: 'Trimis {{time}}',
  breakdown_title: 'Rezumat livrare',
  pending_receipts: {
    title: 'Statisticile de livrare sunt în curs',
    description:
      'Această campanie tocmai a fost trimisă. Furnizorii de push confirmă livrarea la aproximativ 15 minute după trimitere, astfel cifrele de mai jos vor fi completate în jurul orei {{time}} — nicio acțiune necesară.',
    countdown:
      'Apple și Google confirmă recepțiile în aproximativ {{minutes}}m {{seconds}}s (în jurul orei {{time}}). Statisticile se vor actualiza automat.',
    ready: 'Recepțiile ar trebui să fie disponibile. Cifrele de mai jos se actualizează acum.',
    soon: 'în curând',
  },
  recipients: {
    title: 'Destinatari',
    subtitle: 'Cui i-a fost trimisă această campanie și dacă a ajuns pe dispozitivul lor.',
    filters: {
      all: 'Toți',
      delivered: 'Livrat',
      pending: 'În așteptarea confirmării',
      failed: 'Nelivrat',
    },
    columns: {
      recipient: 'Destinatar',
      status: 'Stare',
      reason: 'Motiv',
      clicked: 'Accesat',
      sent_at: 'Trimis la',
    },
    status: {
      delivered: 'Livrat',
      pending: 'În așteptarea confirmării',
      failed: 'Nelivrat',
    },
    reasons: {
      DeviceNotRegistered: 'Aplicație eliminată sau notificări dezactivate (token expirat)',
      MessageRateExceeded: 'Limitat temporar de Expo',
      MessageTooBig: 'Payload notificare prea mare',
      MismatchSenderId: 'Neconcordanță credențiale push',
      InvalidCredentials: 'Credențiale push invalide',
      batch_failed: 'Trimiterea lotului a eșuat',
      missing_ticket: 'Nicio confirmare returnată de Expo',
      unknown: 'Eroare necunoscută de livrare',
    },
  },
};
